// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"8cb4b5f8","458":"8794334a","774":"6524a94a","787":"d3befce1","820":"615a4b9f","851":"3ecd6f9f","858":"73447f70","979":"b6f1f837"}[chunkId] + ".chunk.js";
};